import React, { Fragment } from "react";
import GenericHeader from "../../common/Header";

class HeaderLayout extends React.Component {
  state = {};
  constructor() {
    super();
    this.headerLayout = [
      {
        label: {
          value: "Item",
          size: "50%",
          maxWidth: "150px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "itemNumber",
          autoFocus: true,
          onBlur: "lookup",
          hotMod: false,
        },
        size: "20%"
      },
      {
        label: {
          value: "Description",
          size: "50%",
          maxWidth: "150px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "description"
        },
        readOnly: true,
        size: "30%"
      },
      {
        label: {
          value: "Line",
          size: "50%",
          maxWidth: "150px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "lineCode"
        },
        readOnly: true,
        size: "10%"
      },
      {
        label: {
          value: "Part",
          maxWidth: "150px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "partNumber"
        },
        readOnly: true,
        size: "10%"
      },

      {
        label: {
          value: "Warehouses"
        },
        item: {
          node: "DCSelector",
          value: "",
          onChange: "lookup",

          intemName: "wse"
        },
        size: "30%"
      },
      {
        label: {
          value: "Vendor",
          size: "50%",
          maxWidth: "150px"
        },
        item: {
          node: "input",
          type: "number",
          value: "",
          intemName: "vend",
          size: 1
        },
        size: "20%",
        readOnly: true
      },
      {
        label: {
          value: "Vendor Name",
          size: "50%",
          maxWidth: "150px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "vendorName"
        },
        readOnly: true,
        size: "80%"
      }
    ];
  }
  componentDidMount() {
    this.setState({ layout: this.headerLayout });
  }

  formatData = props => {
    if (props) {
      this.headerLayout.map((layout, key) => {
        if (layout.item.intemName === props[key].name) {
          layout.item.value =
            props[key].value === undefined ||
            props[key].value === "" ||
            props[key].value === false
              ? ""
              : props[key].value;
          layout.item.obj = props[key].obj;
          layout.item.span = props[key].span;
          layout.label.value = props[key].label;
        }
        return null;
      });
    }
    return null;
  };
  getHeaderInfo = info => {
    this.props.setHeaderInfo({ header: info });
  };
  renderHeader = () => {
    this.formatData(this.props.headerData);
    return (
      <GenericHeader
        jsonObj={this.state.layout}
        setHeaderInfo={this.getHeaderInfo}
        functions={{
          lookup: this.props.lookup,
          setErrorMessage: this.props.setErrorMessage,
          setSuccessMessage: this.props.setSuccessMessage
        }}
      />
    );
  };
  render() {
    return <Fragment>{this.renderHeader()}</Fragment>;
  }
}
export default HeaderLayout;
